import * as React from 'react';

import { ChatModal } from '../../components/ChatModal';
import { useChatView } from '../../hooks/useChatView';

export const ChatModalContainer: React.FC = () => {
  const { isOpen, src, onClose, onOpen } = useChatView();

  return <ChatModal isOpen={isOpen} src={src} onClose={onClose} onOpen={onOpen} />;
};

ChatModalContainer.displayName = 'ChatModalContainer';
